<script lang="ts">
  import cx from "classnames";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { Right, Left } from "$components/+blocks/OVIcon";
  import { tooltip } from "app/actions/tooltip";

  export let name: string;
  export let isNext: boolean;
  export let link: string;
</script>

<a
  class:items-start={!isNext}
  class:items-end={isNext}
  class={cx(
    "inline-flex h-fit flex-col justify-center gap-1.5 p-1 transition-all",
    "text-[#707070] hover:text-neutral-700/90 dark:text-neutral-400 dark:hover:text-neutral-300",
    "@xs/main-panel-container:max-w-[110px] @md/main-panel-container:max-w-[165px] @2xl/main-panel-container:max-w-[200px]"
  )}
  href={link}
>
  <div class="inline-flex items-center justify-start">
    <div class="text-[13px] font-medium text-community-primary">
      <div class:flex-row-reverse={!isNext} class="flex w-fit items-center">
        <p class="px-1">{isNext ? "Next" : "Previous"}</p>
        <OVIcon icon={isNext ? Right : Left} class="shrink-0" />
      </div>
    </div>
  </div>
  <div
    class:text-start={!isNext}
    class:text-end={isNext}
    class="w-full truncate text-[13px]"
    title={name}
    use:tooltip
  >
    {name}
  </div>
</a>
